// Package Imports
import { toJS } from "mobx"
import { validationOtherFieldEmpoyees } from "modules/family-details-form/non-individual-journey-form/utils"


const addEmployee = async (
 formController,
 fetchSelectedMembers,
 submitDataToTheServer,
 AuthStore,
 reInitializeFamilyMemberData,
 hideModal) => {
  let { isValid } = await formController.validate({ showErrors: true })
        const ifValid = validationOtherFieldEmpoyees(formController)

        if (ifValid) {
            
        let { members } = formController.values()

        const selectedMemberList = fetchSelectedMembers(members, formController)

        const response = await submitDataToTheServer(formController, selectedMemberList)
        await AuthStore.fetchJourneyData()
        if(hideModal !== undefined){
            hideModal()
        }
        const journeyData = toJS(AuthStore.journeyData)
        console.log("Response data is ", response.data)
        //reInitializeFamilyMemberData(journeyData, formController)

    } else {
        console.log("Error are ", formController.errors())
    }
}

export default addEmployee
